import Car from './Car';

export default Car;
